import styled from 'styled-components';

import { Radio } from 'top-component-library';

export const RadioGroup = styled(Radio.Group)`
  &:not(.button) {
    width: 100%;

    label {
      padding-bottom: 0.375rem;
      width: 100%;

      &:not(:last-of-type) {
        margin-bottom: 0.375rem;
      }

      .ant-radio {
        top: 0.35rem;
      }

      span.ant-radio + * {
        width: 100%;
      }

      & > span:not(.ant-radio) {
        display: flex;
        font-weight: 500;
        font-size: 0.875rem;
        flex-direction: row;
        justify-content: space-between;
        line-height: 1.4;

        span {
          display: inline-block;
        }

        span:first-of-type {
          padding-right: 2rem;
        }
      }
    }
  }
`;
